import React from "react";
import moment from "moment";

const EstatusFacturas = ({ DocsToPrint, ReportsModel, finalDoc }) => {
    const data = (DocsToPrint && DocsToPrint[0]) || {};
    const {
        listFacturas = [],
        SumTotal = 0,
        SumPaidToDate = 0,
        SumSaldoPendiente = 0,
    } = data;

    const printFixStyles = `
        @media print {
            .estatus-facturas-header th {
                background: #343a40 !important;
                color: white !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
            }
        }
    `;

    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const formatDate = (value) => {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY');
    };

    const estatusBadgeClass = (estatus) => {
        switch (estatus) {
            case 'Pagada': return 'text-success font-weight-normal';
            case 'Pago parcial': return 'text-warning font-weight-normal';
            case 'Pendiente': return 'text-danger font-weight-normal';
            case 'Cancelada': return 'text-secondary font-weight-normal';
            default: return '';
        }
    };

    return (
        <div className="p-3" style={{ fontSize: '12px' }}>
            <style>{printFixStyles}</style>
            <div className="text-center mb-3">
                <h4>Reporte de Estatus de Facturas</h4>
                <p>
                    Del {formatDate(ReportsModel?.InitialDate)} al {formatDate(ReportsModel?.FinalDate)}
                    {ReportsModel?.SucursalName ? ` — Sucursal: ${ReportsModel.SucursalName}` : ''}
                    {ReportsModel?.UserName ? ` — Usuario: ${ReportsModel.UserName}` : ''}
                </p>
            </div>

            <table className="table table-bordered table-sm">
                <thead>
                    <tr className="estatus-facturas-header" style={{ background: '#343a40', color: 'white', WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
                        <th className="text-center">Folio</th>
                        <th className="text-center">Fecha</th>
                        <th className="text-center">Cliente</th>
                        <th className="text-center">Sucursal</th>
                        <th className="text-center">Usuario</th>
                        <th className="text-center">Condición</th>
                        <th className="text-center">Tipo doc.</th>
                        <th className="text-center">Doc. relacionado</th>
                        <th className="text-center">Total</th>
                        <th className="text-center">Pagado</th>
                        <th className="text-center">Saldo</th>
                        <th className="text-center">Estatus factura</th>
                        <th className="text-center">Estatus cobranza</th>
                        <th className="text-center">Pagos aplicados</th>
                    </tr>
                </thead>
                <tbody>
                    {listFacturas.length === 0 &&
                        <tr>
                            <td colSpan="14" className="text-center">No se encontraron facturas para los filtros seleccionados</td>
                        </tr>
                    }
                    {listFacturas.map((factura, index) => (
                        <tr key={factura.DocEntry ?? index}>
                            <td className="text-center">{factura.NumAtCard || factura.DocNum}</td>
                            <td className="text-center">{formatDate(factura.DocDate)}</td>
                            <td className="text-center">{factura.CardName}</td>
                            <td className="text-center">{factura.Sucursal}</td>
                            <td className="text-center">{factura.UsuarioCreador}</td>
                            <td className="text-center">{factura.CondicionPago}</td>
                            <td className="text-center">{factura.TipoDocumento}</td>
                            <td className="text-center">
                                {factura.FacturaRelacionada
                                    ? `${factura.FacturaRelacionada} (${factura.DocumentoRelacionado || ''})`
                                    : '—'}
                            </td>
                            <td className="text-center">{formatMoney(factura.DocTotal)}</td>
                            <td className="text-center">{formatMoney(factura.PaidToDate)}</td>
                            <td className="text-center">{formatMoney(factura.SaldoPendiente)}</td>
                            <td className="text-center">{factura.EstatusFactura}</td>
                            <td className="text-center">
                                <span className={estatusBadgeClass(factura.EstatusCobranza)}>
                                    {factura.EstatusCobranza}
                                </span>
                            </td>
                            <td className="text-center">{factura.PagosRelacionados || '—'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EstatusFacturas;